import type { NewsItem } from "@site-types/content"
import type { CSSProperties } from "react"
import { imageRenderProps } from "../../componentUtils"
import OptimizedImage from "../../OptimizedImage"
export function NewsCard({
  post,
  detail = false,
  priority = false,
}: {
  post: NewsItem
  detail?: boolean
  priority?: boolean
}) {
  if (!post.newsCoverImage) return null
  const transitionName = `news-${post.slug?.current}`
  const transitionStyle = { viewTransitionName: transitionName } as CSSProperties
  const imagePreset = detail ? "newsDetail" : "newsCard"
  const isPriority = detail || priority
  const image = (
    <OptimizedImage
      className={`block aspect-video h-auto w-[var(--image-width,100%)] bg-[var(--green)] object-cover ${
        detail ? "max-w-full" : ""
      }`}
      alt={post.title ?? ""}
      loading={isPriority ? "eager" : "lazy"}
      decoding="async"
      fetchPriority={isPriority ? "high" : "auto"}
      {...imageRenderProps(post.newsCoverImage, imagePreset)}
    />
  )

  if (detail) {
    return (
      <div
        data-testid="news-card-detail"
        data-content-transition-name={transitionName}
        data-content-transition-element="true"
        data-news-transition-name={transitionName}
        data-news-transition-element="true"
        style={transitionStyle}
      >
        {image}
      </div>
    )
  }
  return (
    <div
      data-testid="news-card"
      data-content-transition-name={transitionName}
      data-content-transition-element="true"
      data-news-transition-name={transitionName}
      data-news-transition-element="true"
    >
      {image}
    </div>
  )
}

export default NewsCard
